import * as c from './AddressSearchFieldConstants';

export function setResults(id, results) {
  return { type: c.SET_RESULTS, payload: { id, results } };
}

export function setSelectedTerm(id, selectedTerm, form) {
  return { type: c.SET_SELECTED_TERM, payload: { id, selectedTerm }, form };
}

export function getResults(id, searchTerm) {
  return { type: c.GET_RESULTS, payload: { id, searchTerm } };
}

export function setLoadStatus(id, status) {
  return { type: c.SET_LOAD_STATUS, payload: { id, status } };
}

export function setError(id, error) {
  return { type: c.SET_ERROR, payload: { id, error } };
}

export function insertNewField(parentForm, form, index) {
  return { type: c.INSERT_NEW_KEY, payload: { parentForm, form, index } };
}
